import {css} from '@emotion/css';

import {colours} from '../../../../styles/js/variables';

const styles = {
  container: css`
    label: generalLayout__container;
    display: flex;
    flex-direction: column;
    // stylelint-disable-next-line unit-allowed-list
    min-height: 100vh;
    background: ${colours.background.MAIN};
  `,
  inner: css`
    label: generalLayout__inner;
    flex-grow: 1;
  `,
};

export default styles;
